import Vue from 'vue'

Vue.filter('formatRadToDeg', function(value:number) {
  if (value) {            
    return (((value * 57.2958) + 360.0) % 360).toFixed(2) + "°"
  }
})